import { Controller } from "@hotwired/stimulus"

// Deep-dive toggle in the chat composer: flips the hidden research_mode
// input ''<->'1' and the active styling on the chip.
export default class extends Controller {
  static targets = ["input", "button"]

  toggle() {
    const on = this.inputTarget.value !== "1"
    this.inputTarget.value = on ? "1" : ""
    this.buttonTarget.classList.toggle("laz-research-active", on)
  }
}
